import { observable, computed } from 'mobx';
import NotificationsCollection from '../../../domain/entities/Notification/NotificationsCollection';
import TransactionRepository from '../../../repositories/TransactionRepository';
import Config from '../../../domain/entities/Config';
import ConfigRepository from '../../../repositories/ConfigRepository';

export interface IBaseNotificationManagerConfig {
  configRepository: ConfigRepository;
  notificationsCollection: NotificationsCollection;
  transactionRepository: TransactionRepository;
}

export default abstract class BaseNotificationManager {
  protected transactionRepository: TransactionRepository;

  protected configRepository: ConfigRepository;

  @observable notificationsCollection: NotificationsCollection;

  @computed
  protected get config(): Config {
    return this.configRepository.config;
  }

  constructor(config: IBaseNotificationManagerConfig) {
    this.configRepository = config.configRepository;
    this.notificationsCollection = config.notificationsCollection;
    this.transactionRepository = config.transactionRepository;
  }

  abstract init(): void;
}